import { api } from '../boot/axios'

export async function fetchStripeConnectStatus () {
  const { data } = await api.get('/payments/stripe/status')
  return data
}

export async function createStripeConnectAccount () {
  const { data } = await api.post('/payments/stripe/account')
  return data
}

export async function createStripeConnectAccountSession (options = {}) {
  const { data } = await api.post('/payments/stripe/account-session', options)
  return data
}

export async function fetchOnlineGatewayProfile () {
  const { data } = await api.get('/business-info/payments/online-gateway')
  return data
}
